// frontend/src/components/notifications/NotificationItem.js
import { useNavigate } from 'react-router-dom';
import { FiTrash2 } from 'react-icons/fi';
import { useNotifications } from '../../context/NotificationContext';
import { resolveNotificationLink } from '../../config/notificationRoutes';
import styles from './NotificationItem.module.css';

const timeAgo = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};

const NotificationItem = ({ notification, onClose }) => {
  const navigate = useNavigate();
  const { markRead, removeNotification } = useNotifications();

  const handleClick = async () => {
    if (!notification.isRead) await markRead(notification.id);
    const link = resolveNotificationLink(notification.type, notification.metadata || {});
    navigate(link);
    onClose();
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    await removeNotification(notification.id);
  };

  return (
    <div
      className={`${styles.item} ${!notification.isRead ? styles.unread : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      {!notification.isRead && <span className={styles.dot} />}
      <div className={styles.body}>
        <p className={styles.title}>{notification.title}</p>
        <p className={styles.message}>{notification.message}</p>
        <span className={styles.time}>{timeAgo(notification.createdAt)}</span>
      </div>
      <button className={styles.deleteBtn} onClick={handleDelete} title="Delete" aria-label="Delete notification">
        <FiTrash2 size={14} />
      </button>
    </div>
  );
};

export default NotificationItem;
